import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import {useSelector} from 'react-redux';
import { add_to_wishlist, wishlistItems } from '../../../redux/features/wishlist-slice';

const ModuloGrid = ({ itemsPerPage, items, col = "col-xxl-4 col-xl-4 col-lg-4 col-md-6" }) => {

  console.log('items: ' + items);

  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const dispatch = useDispatch();
  const wishlists = useSelector(wishlistItems)

  useEffect(() => {

    console.log('useEffect');
    console.log(items);

    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(items?.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, items]);


  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);
  };

  // handle wishlist
  const handleWishList = (course) => {
    dispatch(add_to_wishlist(course));
  }

  return (
    <>
      {currentItems && currentItems.map((modulo, index) => (
        <div key={index} className={col}>
          <div className="course__item white-bg mb-30 fix">
            <div className="course__thumb w-img p-relative fix">
              <Link to={`/modulo/aula/${modulo.cd_modulo}`}>
                <img src={"https://v1.profaprizattera.com.br/uploads/modulo/" + modulo.file} alt="" />
              </Link>
            </div>
            <div className="course__content">
              <div className="course__meta d-flex align-items-center justify-content-between">
                <div className="course__lesson">
                  {/* <span><i className="far fa-book-alt"></i>Redação Online</span> */}
                </div>
                
              </div>
              <h3 className="course__title">
                <Link to={`/modulo/aula/${modulo.cd_modulo}`}>{modulo.titulo}</Link>
              </h3>
              
            </div>
            <div className="course__more d-flex justify-content-between align-items-center">
              
              <div className="course__btn">
                <Link to={`/modulo/aula/${modulo.cd_modulo}`} className="link-btn">
                  Saiba mais
                  <i className="far fa-arrow-right"></i>
                  <i className="far fa-arrow-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}

    </>
  );
};

export default ModuloGrid;